<!--
  @Description cgc 拼团mvp - 奖品图
-->
<template>
<div class="group_mvp_process_prize">
  <img :src="backgroundImg && backgroundImg !== '' ? backgroundImg : defaultImg" />
  <div class="prize_desc">
    <div class="text">{{prizeDesc}}</div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    backgroundImg: {
      type: String,
      default: () => ''
    },
    prizeDesc: {
      type: String,
      default: () => ''
    }
  },
  computed: {
  },
  data () {
    return {
      defaultImg: require('../../../../assets/images/cgc/didi/mvp-gift-default.png')
    }
  }
}
</script>
<style scoped lang="stylus">
.group_mvp_process_prize
  display flex
  flex-direction column
  justify-content center
  align-items center
  img
    border-radius: 148px
    width 148px
    height 148px
    margin-bottom -35px
  .prize_desc
    width fit-content
    height 38px
    background #FF8040
    border 2px solid #FFFFFF
    border-radius 38px
    text-align center
    display flex
    align-items center
    justify-content center
    .text
      min-width 150px
      max-width 170px
      height 28px
      border-radius 28px
      font-family PingFangSC-Regular
      font-size 22px
      color #FFFFFF
      line-height 28px
      font-weight 400
      overflow hidden
      white-space nowrap
      text-overflow ellipsis

</style>